<template>
  <v-container fluid class="pa-0">
    <v-card>
      <v-card-title class="grey lighten-4 py-0">
        <span class="title primary--text">Top skills you train on (not more than 10)</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon flat @click.native="addSkill" v-if="skillList.length !== 0">
          <v-icon>add</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <div v-if="skillList.length === 0" class="text-xs-center mt-2">
          <v-btn @click.native="addSkill" round color="primary">Add Skill</v-btn>
        </div>
        <v-list v-else three-line>
          <template v-for="(skillEntity , index) in skillList">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>assistant</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="flex">
                  {{skillEntity.skillName}}
                  <v-chip
                  color="secondary"
                  small
                  text-color="white" v-for="(subSkill, index) in skillEntity.subSkills" :key="index" class="mb-2">{{subSkill}}</v-chip>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{skillEntity.experienceYears}}&nbsp;years of experience&nbsp;&amp;&nbsp;{{skillEntity.numberOfTrainings}}&nbsp;trainings
                  <!-- From: {{workEntity.startDate}} &nbsp; To: {{workEntity.endDate}} -->
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  {{skillEntity.seniority}}&nbsp;({{skillEntity.workProfile}})
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn color="primary" flat icon @click.native="editSkill(skillEntity)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 !== skillList.length"></v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog.open" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialog.open = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-model="deleteDialogOpen"
              :close-on-content-click="false" v-show="skill.id !== null">
            <v-btn flat dark slot="activator">Delete</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline error--text">Delete Data</span>
              </v-card-title>
              <v-card-text>
                Sure you want to delete this record?
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" outline round @click.native="deleteDialogOpen = false">No</v-btn>
                <v-btn color="error" round @click.native="deleteSkill" :loading="loading" :disabled="loading">Yes</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
            <v-btn dark flat @click.native="saveSkill" :loading="loading" :disabled="loading">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="skillForm">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field name="skillName" label="Skill / Technology / Tool" :counter="128" value="Input text" v-model="skill.skillName" :rules="rules.skillName" box required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                  class="elevation-0"
                  v-model="skill.subSkills"
                  label="Add sub skills and press enter to separate (optional)"
                  chips
                  box
                  multiple
                  clearable
                  placeholder="After typing press enter to input more values"
                  >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                    :selected="data.selected"
                    close
                    @input="remove(data.item)"
                    color="secondary"
                    text-color="white"
                    small
                    >
                    <strong>{{ data.item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field name="experienceYears" mask="##" label="Total Training Experience" v-model="skill.experienceYears" :rules="rules.experienceYears" box required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field name="numberOfTrainings" mask="####" label="No. Of Trainings" v-model="skill.numberOfTrainings" :rules="rules.numberOfTrainings" box required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-subheader class="pa-0"><h2>Target Audience</h2></v-subheader>
            </v-flex>
            <v-flex xs12>
            <span>For which target audience</span>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
              :items="items"
              v-model="skill.seniority"
              label="Experience level"
              box
              item-value="text"
              required
              :rules="rules.isRequired"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field name="workProfile" label="Work Profile" value="Input text" placeholder="Engineers, supervisors, sales team etc" v-model="skill.workProfile" :rules="rules.workProfile" :counter="64" box required></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</v-dialog>
</v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'SkillCard',
  data () {
    return {
      deleteDialogOpen: false,
      items: [
        {
          text: 'Freshers',
          value: '1'
        },
        {
          text: 'Mid-level',
          value: '2'
        },
        {
          text: 'Senior-level',
          value: '3'
        },
        {
          text: 'CXO',
          value: '4'
        }
      ],
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        skillName: [
          (v) => !!v || 'Skill Name is required',
          (v) => (v && v.length <= 128) || 'Skill Name must be less than 128 digits'
        ],
        experienceYears: [
          (v) => !!v || 'Experience Years is required',
          (v) => (v && v <= 1000) || 'Experience Years must be less than 3 digits'
        ],
        numberOfTrainings: [
          (v) => !!v || 'Number Of Trainings is required',
          (v) => (v && v <= 10000) || 'Number Of Trainings must be less than 4 digits'
        ],
        workProfile: [
          (v) => !!v || 'Work Profile is required',
          (v) => (v && v.length <= 64) || 'Work Profile must be less than 64 characters'
        ]
      },
      dialog: {
        open: false
      }
    }
  },
  created () {
    Store.dispatch('profile/getSkillList')
  },
  computed: {
    ...mapState('profile', {
      skill: 'skill',
      skillList: 'skillList',
      loading: 'loading'
    }),
    title () {
      if (this.skill.id === null) return 'Add Skill'
      else return 'Edit Skill'
    }
  },
  methods: {
    remove (item) {
      this.skill.subSkills.splice(this.skill.subSkills.indexOf(item), 1)
      this.skill.subSkills = [...this.skill.subSkills]
    },
    cb () {
      this.$refs.skillForm.reset()
      this.deleteDialogOpen = false
      this.dialog.open = false
    },
    editSkill (skill) {
      Store.dispatch('profile/updateSkillForm', { ...skill })
      this.dialog.open = true
    },
    addSkill () {
      Store.dispatch('profile/updateSkillForm', null)
      this.$refs.skillForm.reset()
      this.dialog.open = true
    },
    async deleteSkill () {
      await Store.dispatch('profile/deleteSkill', {id: this.skill.id, cb: this.cb})
    },
    async saveSkill () {
      if (this.$refs.skillForm.validate()) {
        const skill = { ...this.skill }
        await Store.dispatch('profile/saveSkill', { skill, cb: this.cb })
      }
    },
    cancelForm () {
      Store.dispatch('profile/updateSkillForm', null).then(this.cb)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SkillCard.vue